import { z } from 'zod';
// -----------------------------------------------------------------------------
// Presence (Session 18) — a platform primitive. The consumer app shows an
// online dot; the TMS reads the same Redis-backed signal for load routing.
// Read-only HTTP surface here; the write path is the socket gateway.
// -----------------------------------------------------------------------------
/** Max ids per presence lookup — caps the Redis mget fan-out per request. */
export const PRESENCE_MAX_IDS = 200;
/**
 * Query: GET /v1/social/presence?userIds=a,b,c — a comma-separated id list.
 * Split + length-capped here so the route handler receives a clean string[].
 * Empty / whitespace entries are dropped; an empty result is a 400 (ask for
 * at least one id).
 */
export const presenceQuerySchema = z.object({
    userIds: z
        .string()
        .transform((s) => s
        .split(',')
        .map((v) => v.trim())
        .filter(Boolean))
        .pipe(z.array(z.string()).min(1).max(PRESENCE_MAX_IDS)),
});
//# sourceMappingURL=presence.js.map